module.exports = __webpack_public_path__ + "assets/img/benefit-retrieve-61715e07.png";